var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.img && _vm.show,
            expression: "img && show",
          },
        ],
        staticClass: "lightbox",
        class: _vm.original ? "original" : "",
      },
      [
        _c("span", { staticClass: "closer", on: { click: _vm.close } }, [
          _c("i", { staticClass: "iconfont icon-close-fill font-xl" }),
        ]),
        _vm._v(" "),
        _c("i", { staticClass: "aligner" }),
        _vm._v(" "),
        _c("img", { attrs: { src: _vm.img, alt: "img" } }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }